import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/base/Breadcrumb";
import { faqs } from "@/mocks/news";

const BASE_URL = "https://jugxooi.cn";

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${BASE_URL}/` },
        { "@type": "ListItem", position: 2, name: "常见问题", item: `${BASE_URL}/faq` },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="常见问题 - 美日吃瓜 | 内容来源与更新说明"
        description="关于美日吃瓜的内容来源、更新频率、内容原则与投稿方式，这里一次性说明。了解我们如何整理娱乐圈热点，以及我们坚持的三条底线。"
        keywords="美日吃瓜常见问题,美日吃瓜内容来源,美日吃瓜更新频率,美日吃瓜投稿"
        canonical="/faq"
        jsonLd={jsonLd}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "常见问题" }]} />
      <main>
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto max-w-content px-4 py-12 text-center md:px-6 md:py-16">
            <span className="inline-flex items-center gap-2 rounded-full border border-accent-300 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-question-line" aria-hidden="true" />
              Help Center
            </span>
            <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              常见问题
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              如果你刚接触「美日吃瓜」，这些答案能帮你快速了解我们是谁、内容从哪来、又该怎样理性地看待娱乐圈热点。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
          <div className="mx-auto max-w-3xl">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <h2>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                      >
                        <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                          {faq.q}
                        </span>
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border transition-colors ${
                            isOpen
                              ? "border-primary-500 bg-primary-500 text-background-50"
                              : "border-background-300 text-foreground-500"
                          }`}
                        >
                          <i
                            className={isOpen ? "ri-subtract-line text-sm" : "ri-add-line text-sm"}
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </h2>
                    {isOpen ? (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>

            <div className="mt-10 rounded-lg border border-primary-200 bg-primary-50 p-6 text-center md:p-8">
              <h2 className="font-heading text-lg font-bold text-primary-900">
                还有别的问题想问？
              </h2>
              <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-primary-800">
                欢迎直接写邮件给我们，无论是内容建议、线索投稿还是合作咨询，我们都会在三个工作日内回复。
              </p>
              <div className="mt-5 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href="mailto:hello@meirichigua.com"
                  rel="nofollow"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-mail-line" aria-hidden="true" />
                  hello@meirichigua.com
                </a>
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
                >
                  了解更多关于我们
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}